import { Injectable } from '@angular/core';
import DOMPurify from 'dompurify';

@Injectable({
  providedIn: 'root'
})
export class SafeHtmlService {
  sanitize(html: string): string {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['p', 'br', 'span', 'div'], 
      ALLOWED_ATTR: [],
      FORBID_TAGS: [
        'script', 'iframe', 'object', 'embed', 'svg', 'math', 
        'form', 'input', 'button', 'a', 'img'
      ],
      FORBID_ATTR: ['onerror', 'onload', 'onclick', 'href', 'src', 'style']
    });
  }

  sanitizeTextOnly(html: string): string {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: []
    });
  }
}
